import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { addClass, find, findAll, hasClass, removeClass } from '@fretadao/f-js-dom';
import { isBlank } from '@fretadao/f-js-utils';

application.register(
  'line-schedule-requests-form-target-time-toggle',
  class extends Controller {
    static targets = ['schedule', 'diff', 'destinationTimeFields'];
    static values = {
      filterByFieldset: {
        type: Boolean,
        default: false
      }
    };

    FIXED_TIMES = ['schedule_arrival', 'schedule_departure'];
    TIME_INTERVALS = ['anticipated_time', 'delayed_time'];

    toggle(event) {
      if (this.filterByFieldsetValue) {
        this.#toggleWithFieldset(event);
      } else {
        this.#basicToggle(event);
      }
    }

    showDepartureFields({ target }) {
      const fieldset = target.closest('fieldset:not([disabled])');

      if (this.hasDestinationTimeFieldsTarget && fieldset) {
        let inputFields = findAll('input', this.destinationTimeFieldsTarget);

        if (target.checked) {
          removeClass(this.destinationTimeFieldsTarget, 'hidden');
          addClass(this.destinationTimeFieldsTarget, 'sm:grid');
          const schedule = find('[data-line-schedule-requests-form-target-time-toggle-target="schedule"]', fieldset);
          const scheduleInput = find('input', schedule);
          const diff = find('[data-line-schedule-requests-form-target-time-toggle-target="diff"]', fieldset);
          const diffInput = find('input', diff);
          const targetValue = find('#line_schedule_change_request_time_shift_type', fieldset)?.value;

          if (this.FIXED_TIMES.includes(targetValue)) {
            this.#hideChild(diff, diffInput);
            this.#showChild(schedule, scheduleInput);
          } else if (this.TIME_INTERVALS.includes(targetValue)) {
            this.#hideChild(schedule, scheduleInput);
            this.#showChild(diff, diffInput);
          }

          inputFields.forEach((input) => {
            const inputContainer = input.closest('.Form-inputGroup');

            if (!hasClass(inputContainer, 'hidden')) {
              input.required = true;
            }
          });
        } else {
          removeClass(this.destinationTimeFieldsTarget, 'sm:grid');
          addClass(this.destinationTimeFieldsTarget, 'hidden');

          inputFields.forEach((input) => {
            input.required = false;
            input.value = null;
          });
        }
      }
    }

    #basicToggle(event) {
      const scheduleInput = find('input', this.scheduleTarget);
      const diffInput = find('input', this.diffTarget);

      let targetValue = event.target.value;

      if (this.FIXED_TIMES.includes(targetValue)) {
        this.#hideChild(this.diffTarget, diffInput);
        this.#showChild(this.scheduleTarget, scheduleInput);
      } else if (this.TIME_INTERVALS.includes(targetValue)) {
        this.#hideChild(this.scheduleTarget, scheduleInput);
        this.#showChild(this.diffTarget, diffInput);
      } else if (isBlank(targetValue)) {
        this.#hideChild(this.scheduleTarget, scheduleInput);
        this.#hideChild(this.diffTarget, diffInput);
      }
    }

    #toggleWithFieldset(event) {
      const fieldset = event.target.closest('fieldset:not([disabled])');
      const schedule = find('[data-line-schedule-requests-form-target-time-toggle-target="schedule"]', fieldset);
      const scheduleInput = find('input', schedule);
      const diff = find('[data-line-schedule-requests-form-target-time-toggle-target="diff"]', fieldset);
      const diffInput = find('input', diff);
      const targetValue = event.target.value;

      if (this.FIXED_TIMES.includes(targetValue)) {
        this.#hideChild(diff, diffInput);
        this.#showChild(schedule, scheduleInput);
      } else if (this.TIME_INTERVALS.includes(targetValue)) {
        this.#hideChild(schedule, scheduleInput);
        this.#showChild(diff, diffInput);
      }
    }

    #hideChild(container, input) {
      addClass(container, 'hidden');
      input.value = null;
      input.required = false;
    }

    #showChild(container, input) {
      removeClass(container, 'hidden');
      input.required = true;
    }
  }
);
